import { findAndUpdate } from '~utils/array';

import { targets } from './actions';

export const onRejectedOrdersUpdate = () => (state, { payload }) => {
  const [updatedOrders] = findAndUpdate(
    (order) => order.id === payload.id,
    (order) => ({
      ...order,
      adminUserId: payload.adminUserId,
      adminUserData: payload.adminUserData
    }),
    state[targets.REJECTED_ORDERS].page
  );
  return state.merge({
    ...state,
    [targets.REJECTED_ORDERS]: {
      ...state[targets.REJECTED_ORDERS],
      page: updatedOrders
    },
    assignedOrderLoading: false
  });
};
